// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { Checkbox } from '@mantine/core';

import type { RenderableSpool } from 'components/Autodesk/extensions/SpoolsExtension/types';
import type { GridMenuProps } from 'components/Mantine/GridMenu';
import { SpoolCard } from 'modules/Shop/Spooling/Assigning/SpoolCard';

type Props<T extends string> = {
  spool: RenderableSpool;
  selectedSpools: RenderableSpool['name'][];
  isVisible: boolean;
  toggleVisibility: () => void;
  onSpoolSelected: (selected: boolean) => void;
  disabled?: boolean;
  menuProps?: GridMenuProps<T>;
  beforeTitle?: ReactNode;
  hasFabricationElements?: boolean;
};

/**
 * Wrapper around SpoolCard which adds a selection checkbox.
 */
export const SelectableSpool = <T extends string = ''>({
  spool,
  selectedSpools,
  isVisible,
  toggleVisibility,
  onSpoolSelected,
  disabled,
  beforeTitle,
  hasFabricationElements,
  menuProps,
}: Props<T>) => (
  <SpoolCard
    spool={spool}
    isVisible={isVisible}
    toggleVisibility={toggleVisibility}
    disableVisibility={disabled || selectedSpools.length > 0}
    leftSection={
      <Checkbox
        disabled={disabled}
        checked={selectedSpools.includes(spool.name)}
        onChange={(e) => {
          onSpoolSelected(e.currentTarget.checked);
        }}
      />
    }
    beforeTitle={beforeTitle}
    hasFabricationElements={hasFabricationElements}
    menuProps={menuProps}
  />
);
